import { isEmpty } from 'lib/util';
import { getImageUrlWithParams, removeDimensions } from 'lib/url-adapter';

export default function getPlayerBackgroundStyle(content) {
    if (!isEmpty(content)) {
        const bgUrl = getImageUrlWithParams(removeDimensions(content.imageHref), { cquality: 40 });
        const backgroundImage = `url(${bgUrl})`;
        return { backgroundImage, backgroundSize: 'cover' };
    }
    return {};
}



// WEBPACK FOOTER //
// ./app/webapp/player/util/getPlayerBackgroundStyle.js